import { render, staticRenderFns } from "./ClosestPopulationView.vue?vue&type=template&id=40c6f88f&scoped=true"
import script from "./ClosestPopulationView.vue?vue&type=script&lang=js"
export * from "./ClosestPopulationView.vue?vue&type=script&lang=js"
import style0 from "./ClosestPopulationView.vue?vue&type=style&index=0&id=40c6f88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6f88f",
  null
  
)

export default component.exports